type Variant = 'loading' | 'error' | 'info' | 'success'

interface StatusMessageProps {
  message: string
  variant: Variant
  errorId?: string | null
}

function getVariantStyle(variant: Variant): string {
  switch (variant) {
    case 'loading':
      return 'border-blue-200 bg-blue-50 text-blue-800'
    case 'error':
      return 'border-red-200 bg-red-50 text-red-800'
    case 'info':
      return 'border-yellow-200 bg-yellow-50 text-yellow-800'
    case 'success':
      return 'border-green-200 bg-green-50 text-green-800'
  }
}

function StatusMessage({ message, variant, errorId }: StatusMessageProps) {
  return (
    <div className={`rounded-lg border p-6 text-center ${getVariantStyle(variant)}`}>
      <p className="text-lg">{message}</p>
      {errorId ? (
        <p className="mt-2 font-mono text-xs opacity-80">
          Reference ID: <span data-testid="error-id">{errorId}</span>
        </p>
      ) : null}
    </div>
  )
}

export default StatusMessage
